module.exports = __webpack_public_path__ + "img/755.ded6cdef.jpg";